import { useEffect, useState } from "react";
import useRecoveryPassord from "../../api/hooks/password/useRecoveryPassword";
import Footer from "../../components/Footer";
import FeedMessage from "../../components/misc/FeedMessage";
import LogMessage from "../../components/misc/LogMessage";
import { toAssets, toIllustrations } from "../../consts/Paths";
import useIsMobile from "../../hooks/useIsMobile";
import useLogMessage from "../../hooks/useLogMessage";
import useToggle from "../../hooks/useToggle";
import "../../styles/Access.css";
import "../../styles/General.css";

const VerifyPage = (props: any) => {
  const { isMobile } = useIsMobile();
  const showFeedMessage = useToggle(false);
  const { isToggled, message, write } = useLogMessage();
  const { recoveryPasswordResponse, recoveryPasswordResult, recoveryPassword } =
    useRecoveryPassord();

  const [email, setEmail] = useState<string | null>(null);
  

  useEffect(() => {
    if (email) {
      recoveryPassword(email);
    }
  }, [email]);

  useEffect(() => {
    /* console.log(recoveryPasswordResponse, recoveryPasswordResult); */
    if (recoveryPasswordResponse?.ok) {
      showFeedMessage.toggle();
    } else {
      write("subject", `${recoveryPasswordResponse?.status}: `);
      write("other_text", `${recoveryPasswordResponse?.statusText}: `);
    }
  }, [recoveryPasswordResponse]);

  useEffect(() => {
    const url = new URL(window.location.href);
    const tEmail = url.searchParams.get("email");
    console.log(tEmail);
    if (tEmail) {
      setEmail(tEmail);
    } else if (!tEmail) {
      window.location.href = window.location.origin + "/login";
    }
  }, []);

  return (
    <div className="access-background">
      <img className="Logo_2-POS4x" src={`${toAssets}/Logo_2-POS@4x.png`} />
      <FeedMessage
        imageBgClassName="mailImage-background"
        imageSrc={`${toIllustrations}/congrats.svg`}
        title="E-mail sent"
        description={`Verification success, we send you an email in order to reset your password.`}
        link={{ path: "/login", text: "Return to Log In" }}
      />
      {isToggled && (
        <LogMessage
          text={{
            subject: message.subject,
            other_text: message.other_text,
            complement: message.complement,
          }}
          bgColor={message.bgColor}
        />
      )}
      <Footer />
    </div>
  );
};
export default VerifyPage;
